import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Package, ArrowRight } from 'lucide-react';

const CategoryCard = ({ category, onClick, index }) => {
  const { t } = useTranslation();
          <h3 className="text-xl font-bold text-gray-900">{t(category.name)}</h3>
  return (
    <motion.div
      className="bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -5, scale: 1.02 }}
      onClick={() => onClick(category)}
    >
      <div className="relative h-48 overflow-hidden">
        <img 
          src={category.image} 
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute bottom-4 left-4 text-white">
          <div className="flex items-center gap-2 mb-1">
            <Package className="w-4 h-4" />
            <span className="text-sm font-medium">
              {category.productCount} {(() => {
                if (category.name.toLowerCase().includes('hotel')) return 'Hoteles';
                if (category.name.toLowerCase().includes('servicio')) return 'Servicios';
                if (category.name.toLowerCase().includes('nieve')) return 'Productos';
                if (category.name.toLowerCase().includes('all inclusive')) return 'Productos';
                if (category.name.toLowerCase().includes('programas')) return 'Programas';
                return 'Productos';
              })()}
            </span>
          </div>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
            <h3 className="text-xl font-bold text-gray-900">{t(category.name)}</h3>
          <motion.div
            className="p-2 bg-blue-50 rounded-full group-hover:bg-blue-100 transition-colors"
            whileHover={{ rotate: 45 }}
          >
            <ArrowRight className="w-4 h-4 text-blue-600" />
          </motion.div>
        </div>
        
        <p className="text-gray-600 text-sm leading-relaxed">
          {category.description}
        </p>
        
        <div className="mt-4 pt-4 border-t border-gray-100">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500">Disponible para:</span>
            <div className="flex gap-1">
              <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full font-medium">
                Agencias
              </span>
              <span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full font-medium">
                Admin
              </span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CategoryCard;